import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { ProgramsSection } from '../components/ProgramsSection';
export function ProgramsPage() {
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-709">
      <Header data-id="element-710" />
      <main className="w-full font-sans" data-id="element-711">
        <PageHeader title="Our Programs" subtitle="Discover the initiatives that drive our mission to uplift lives and transform communities" badgeText="PROGRAMS & INITIATIVES" bgColor="bg-gradient-to-r from-sfrr-green to-sfrr-blue" data-id="element-712" />
        <ProgramsSection data-id="element-713" />
        {/* Additional Program Details */}
        <section className="py-16 bg-white" data-id="element-714">
          <div className="container mx-auto px-4" data-id="element-715">
            <div className="max-w-3xl mx-auto" data-id="element-716">
              <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-6" data-id="element-717">
                How Our Programs Work
              </h2>
              <div className="space-y-8" data-id="element-718">
                <div className="bg-warm-ivory rounded-lg p-6 shadow-soft" data-id="element-719">
                  <h3 className="text-xl font-bold text-sfrr-green mb-4" data-id="element-720">
                    Program Development
                  </h3>
                  <p className="text-charcoal/80" data-id="element-721">
                    Our programs are developed based on thorough needs
                    assessments in target communities. We engage local
                    stakeholders to ensure our initiatives address the most
                    pressing needs and have sustainable impact.
                  </p>
                </div>
                <div className="bg-warm-ivory rounded-lg p-6 shadow-soft" data-id="element-722">
                  <h3 className="text-xl font-bold text-sfrr-pink mb-4" data-id="element-723">
                    Implementation Approach
                  </h3>
                  <p className="text-charcoal/80" data-id="element-724">
                    We implement our programs through a collaborative approach,
                    working with community leaders, local government, and other
                    stakeholders. This ensures local ownership and
                    sustainability of our initiatives.
                  </p>
                </div>
                <div className="bg-warm-ivory rounded-lg p-6 shadow-soft" data-id="element-725">
                  <h3 className="text-xl font-bold text-sfrr-blue mb-4" data-id="element-726">
                    Monitoring & Evaluation
                  </h3>
                  <p className="text-charcoal/80" data-id="element-727">
                    All our programs undergo rigorous monitoring and evaluation
                    to measure impact and identify areas for improvement. We are
                    committed to transparency and accountability in all our
                    work.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-728" />
    </div>;
}